import { Component, ReactNode } from "react"

import moment from "moment"

import { BaseEnumType } from "../../libs/initialization/remoteInits"

import Select from "../../libs/ui/inputs/Select"


const YEARS_TO_VIEW = Number(30)

interface YearProps {
    id: string 
    label: string

    value : number | undefined
    valueError : string | undefined

    cutOffYear? : number | undefined

    regexp: Function
    callBack: Function
}

interface YearState {
    yearsToDisplay: BaseEnumType[]
    maxYear: number
    error: string | undefined
}

class Year extends Component<YearProps, YearState> {
    constructor (props: any) {
        super (props)
        
        const max = this.getNumberOfYearsToShow( this.props.cutOffYear )

        this.state = {
            maxYear: max,
            yearsToDisplay: this.getPossibleYears( max ),
            error: undefined
        }

        this.update = this.update.bind(this)
        this.validate = this.validate.bind(this)
    }

    componentDidUpdate(prevProps: Readonly<YearProps>, prevState: Readonly<YearState>, snapshot?: any): void {
        if (
            this.props.cutOffYear !== undefined && prevProps.cutOffYear !== this.props.cutOffYear // ho un anno limite
        ) {
            // ho 2021 - sono nel 2024: devo mostrare [2021, 2022, 2023, 2024] 
            let max = this.getNumberOfYearsToShow( this.props.cutOffYear )

            if ( max !== this.state.maxYear ) {
                // ed è diverso dal massimo di anni da visualizzare
                this.setState({
                    maxYear: max,
                    yearsToDisplay: this.getPossibleYears( max ),
                })
            }
        }
    }

    render (): ReactNode {
        const error = this.props.valueError ?? this.validate (this.props.value)

        return (
            <Select
                id={this.props.id} name={this.props.id} key={this.props.id}
                label={this.props.label} 
                value={this.props.value?.toString()}
                options={ this.state.yearsToDisplay }
                callback={this.update}
                error={error}
                forceReverseSortById={true}
            />
        )
    }

    private update (val: any) {
        this.setState({
            error: this.validate (val)
        }, () => {
            this.props.callBack (val)
        })
    }

    private validate (val: any) {
        return ( !this.props.regexp( val ) )
            ? 'Valore non valido'
            : undefined
    }

    private getNumberOfYearsToShow (cutOff : number | undefined) {
        // se cutOffYear = 2021 
        // posso selezionare (2024 - 2021) + 1 = 4 anni --> 2024, 2023, 2022, 2021
        if (cutOff !== undefined) {
            const current = Number( moment().year() )
            return (current - Number(cutOff)) + 1
        }

        return YEARS_TO_VIEW
    }

    private getPossibleYears ( max: number ): BaseEnumType[] {
        const yearsToDisplay: BaseEnumType[] = []

        const start = moment().year()

        for (let i = 0; i < max && (start - i >= 2000); i++) {
            let current = start - i

            yearsToDisplay.push({
                id: current.toString(),
                value: current.toString()
            })
        }

        return yearsToDisplay
    }
}

export default Year